import React from 'react';
import ReactDOM from 'react-dom/client';

import { ConfigProvider } from 'antd-mobile';
import zhCN from 'antd-mobile/es/locales/zh-CN';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/router';
import { StoreProvider } from '@/store';
import { getLng } from '@/utils/getLng';

/* import i18n from '@/utils/i18n'; */

import 'normalize.css';
import '@/styles/index.less';
import '@/styles/theme.less';

(window as any).useCaptcha = (window as any)._dx?.Captcha(document.getElementById('captcha'), {
  appId: 'daf7bb5737f8a2e8139959205df23c04', //appId，在控制台应用管理或应用配置模块获取
  apiServer: process.env.REACT_APP_IDN_ENV === 'hw' ? 'https://ctu-captcha.iyagame.com' : 'https://ctu-captcha.ewan.cn' ,
  constIDServer: process.env.REACT_APP_IDN_ENV === 'hw' ? 'https://ctu-constantid.iyagame.com/udid/c1' : 'https://ctu-constantid.ewan.cn/udid/c1',
  constID_js: process.env.REACT_APP_IDN_ENV === 'hw' ? 'https://ctu-dx-captcha-js.iyagame.com/ctu-group/constid-js/libs/const-id.js' : 'https://ctu-dx-captcha-js.ewan.cn/ctu-group/constid-js/libs/const-id.js',
  ua_js: process.env.REACT_APP_IDN_ENV === 'hw' ? 'https://ctu-dx-captcha-js.iyagame.com/ctu-group/constid-js/libs/greenseer.js' : 'https://ctu-dx-captcha-js.ewan.cn/ctu-group/constid-js/libs/greenseer.js',
  style: 'popup',
  isSaaS: false,//tpc:'uuid_[1-8 验证码类型]_[1-3 风险等级]', //可选,验证码类型可选值（见 1.2.10）风险等级可选值 1,2,3，值越大，风险等级越高，例如 acbs_1_1width: 300,
  // apiServer域名地址在控制台页面->无感验证->应用管页面左上角获取，必须填写完整包括https://。
});

// 测试切换动态语言
/* setTimeout(() => {
  i18n.changeLanguage('zh')
}, 3000) */

// 根据环境变量设置 HTML 类名
if (process.env.REACT_APP_IDN_ENV === 'hw') {
  document.documentElement.setAttribute('data-theme', 'hw')

  if (getLng() === 'ar') {
    document.querySelector('body').classList.add('rtl');
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <StoreProvider>
    <ConfigProvider locale={zhCN}>
      <RouterProvider router={router} />
    </ConfigProvider>
  </StoreProvider>
  // </React.StrictMode>
);
